import React, { useEffect } from "react";
import ReactModal from "react-modal";
import { atom, useAtomValue, useSetAtom } from "jotai";

ReactModal.setAppElement("#root");

/**
 * Двухуровневая модальная система.
 * modalAtom — основной уровень, modal2Atom — модалка поверх модалки.
 * Открытие: setModal({ children }) / setModal2({ children })
 * Закрытие: closeModal() / closeModal2()
 */
export const modalAtom = atom({ isOpen: false, children: null });
export const modal2Atom = atom({ isOpen: false, children: null });

export const openModalAtom = atom(null, (get, set, children) => {
  set(modalAtom, { isOpen: true, children });
});

export const openModal2Atom = atom(null, (get, set, children) => {
  set(modal2Atom, { isOpen: true, children });
});

export const closeModalAtom = atom(null, (get, set) => {
  set(modalAtom, { isOpen: false, children: null });
});

export const closeModal2Atom = atom(null, (get, set) => {
  set(modal2Atom, { isOpen: false, children: null });
});

export const useModal = () => {
  const openModal = useSetAtom(openModalAtom);
  const openModal2 = useSetAtom(openModal2Atom);
  const closeModal = useSetAtom(closeModalAtom);
  const closeModal2 = useSetAtom(closeModal2Atom);

  return { openModal, openModal2, closeModal, closeModal2 };
};

const overlayStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    // Скролл только внутри ModalBody, иначе «едет» вся модалка
    overflow: "hidden",
    width: "auto",
    height: "auto",
    maxWidth: "94vw",
    maxHeight: "92vh",
    padding: 0,
    border: "none",
    borderRadius: "var(--borderRadiusLarge)",
    background: "transparent",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.55)",
    backdropFilter: "blur(2px)",
    zIndex: 50,
  },
};

const AppModal = ({ isOpen, children }) => {
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <ReactModal isOpen={isOpen} style={overlayStyles} portalClassName="modal">
      {children}
    </ReactModal>
  );
};

/** Рендерит оба слоя модалок; подключается один раз в App */
export const ModalRoot = () => {
  const modal = useAtomValue(modalAtom);
  const modal2 = useAtomValue(modal2Atom);

  return (
    <>
      <AppModal isOpen={modal.isOpen}>{modal.children}</AppModal>
      <AppModal isOpen={modal2.isOpen}>{modal2.children}</AppModal>
    </>
  );
};
